import type { PropsWithChildren } from 'react'
import { Icon } from '../Icon'
import { cn } from '../../utils/cn';

type CreditCardCopyNotificationProps = PropsWithChildren & {
  className?: string;
}

export const CreditCardCopyNotification = ( { children, className }: CreditCardCopyNotificationProps ) => {

  return (
    <div className={ cn( 'absolute top-0 inset-x-0 flex flex-row items-center justify-center pointer-events-none', className ) }>
      <div className={ 'flex flex-row items-center text-sm gap-2.5 p-2 backdrop-blur-sm border border-white/20 rounded-[10px] text-white' }>
        <Icon
          name={ 'check' }
          className={ 'text-green-500 text-lg' } />
        {children}
      </div>
    </div>
  )
}
CreditCardCopyNotification.displayName = 'CreditCardCopyNotification';
